import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 58,
      padding: 0,
      margin: 0,
    },

    logoWrapper: {
      height: "100%",
      display: "inline-block",

      "& img": {
        height: 60,
        width: 60,
        textAlign: "left",
      },
    },

    menuNav: {
      "& ul": {
        float: "left",
        listStyleType: "none",
        margin: 0,
        padding: 0,
        overflow: "hidden",

        "&.pr": {
          paddingRight: theme.spacing(7),
        },

        "&.prp": {
          paddingRight: theme.spacing(5),

          [theme.breakpoints.down("xs")]: {
            paddingRight: theme.spacing(0),
          },
        },
      },

      "& ul li": {
        height: 58,
        float: "left",
        marginLeft: theme.spacing(3),

        "& .profileMenuContent": {
          height: "100%",
          width: "100%",
          cursor: "pointer",
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),

          "&:hover": {
            backgroundColor: "#fafafa",
          },

          "& .userIdentity": {
            maxWidth: 100,
            fontSize: 13,
            fontWeight: theme.typography.fontWeightMedium,

            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",

            [theme.breakpoints.down("xs")]: {
              display: "none",
            },
          },

          "& .arrow": {
            marginLeft: "4px",
          },

          "& .userPicture": {
            marginRight: "12px",

            [theme.breakpoints.down("xs")]: {
              marginRight: 0,
            },

            "& img": {
              height: 34,
              width: 34,
              borderRadius: "40px",

              [theme.breakpoints.down("xs")]: {
                height: 28,
                width: 28,
              },
            },
          },
        },
      },

      "& ul li a": {
        height: "100%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

        textDecoration: "none",
        position: "relative",

        fontWeight: theme.typography.fontWeightMedium,
        fontSize: ".8rem",

        "&:hover": {
          color: theme.palette.secondary.main,
        },

        "&.active": {
          color: theme.palette.secondary.main,
        },
      },
    },
  }),
  { name: "signup-menu-style", flip: null }
);
